import { render, staticRenderFns } from "./ComparisonField.vue?vue&type=template&id=5063a91f"
import script from "./ComparisonField.vue?vue&type=script&lang=js"
export * from "./ComparisonField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports